/**
 * Created by rudi on 07/02/14.
 */

OLIVIO.PoleTop = function (draw, lumCallBack, poleClickCallBack) {
  var self = this;

  this.draw = draw;
  this.lumCallBack = lumCallBack;
  this.poleClickCallBack = poleClickCallBack;

  this.isSelectable = true;

  if (typeof lumCallBack === 'undefined' || lumCallBack === null) {
    this.isSelectable = false;
  }

  this.arcAngle = 1;
  this.clockwise = true;

  var textX = 460;
  var textY = 990;

  var textYS1G = 840;
  var textYS2G = 790;
  var textYS3G = 725;

  var textYS1M = 820;
  var textYS2M = 770;
  var textYS3M = 700;

  var textYS3P = 670;

  var textYF = 715;


  var polarToCartesian = function (centerX, centerY, radius, angleInDegrees) {
    var angleInRadians = (angleInDegrees-90) * Math.PI / 180.0;

    return {
      x: (centerX + (radius * Math.cos(angleInRadians))),
      y: (centerY + (radius * Math.sin(angleInRadians)))
    };
  };

  var describeArc = function (x, y, radius, startAngle, endAngle){

    var start = polarToCartesian(x, y, radius, endAngle);
    var end = polarToCartesian(x, y, radius, startAngle);

    var arcSweep = endAngle - startAngle <= 180 ? '0' : '1';
    var d = [
      'M', start.x, start.y,
      'A', radius, radius, 0, arcSweep, 0, end.x, end.y
    ].join(' ');

    return d;
  };

  var getSVGArc = function(angle,color) {
    if (angle >= 359) {
      angle = 359;
    }
    var d = describeArc(750,750,600,0,angle);
    return '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="1500px" height="1500px" viewBox="0 0 1500 1500" enable-background="new 0 0 1500 1500" xml:space="preserve"><path id="progress" fill="none" stroke="'+color+'" d="'+d+'" stroke-width="6"/></svg>';
  } ;

  //this.draw.rect(1500,1500).fill({ color: '#000000', opacity: 0.5 });

  this.rotationPathGroup = this.draw.group();
  this.circBG = this.draw.circle(1200).stroke({ color: '#ffffff', width: 6 }).fill({ color: '#000000', opacity: 0.0 });
  this.rotationPathGroup.add(this.circBG);
  this.circBG.move(150,150);
  this.svgCirc = this.draw.nested();
  this.svgCirc.svg(getSVGArc(36,'#000000'));
  this.rotationPathGroup.add(this.svgCirc);
  this.rotationPathGroup.rotate(180,750,750);


  this.rectStart = this.draw.rect(40, 40);
  this.rectStart.move(750-20,150-20);
  this.rotationPathGroup.add(this.rectStart);
  this.rectEnd = this.draw.rect(40, 40);
  this.rectEnd.move(750-20,150-20);
  this.rotationPathGroup.add(this.rectEnd);

  this.lineDoor = this.draw.line(750, 750, 750, 1450).stroke({ width: 2 });
  self.lineDoor.hide();

  this.rectDistri = this.draw.rect(40, 40).fill({ color: '#000000', opacity: 0.5 });
  this.rectDistri.hide();

  this.lineLastLum = this.draw.line(750, 750, 750, 1450).stroke({ width: 2 });
  self.lineLastLum.hide();

  this.poleTop = new OLIVIO.NestedSVG(draw, SVG2JS.getPartSVG(SVG2JS.OPoletop));
  this.poleTop.group.move(5,12);


  //default to floracion

  this.lumgrp = this.draw.group();
  this.lums = [];
  this.lums[0] = new OLIVIO.NestedSVG(draw, SVG2JS.getPartSVG(SVG2JS.OFTopView), 0, this.lumCallBack,{clickx: 370, clicky: 594, clickwidth: 262, clickheight:600});
  this.lums[1] = new OLIVIO.NestedSVG(draw, SVG2JS.getPartSVG(SVG2JS.OFTopView), 1, this.lumCallBack,{clickx: 370, clicky: 594, clickwidth: 262, clickheight:600});
  this.lums[2] = new OLIVIO.NestedSVG(draw, SVG2JS.getPartSVG(SVG2JS.OFTopView), 2, this.lumCallBack,{clickx: 370, clicky: 594, clickwidth: 262, clickheight:600});
  this.lums[3] = new OLIVIO.NestedSVG(draw, SVG2JS.getPartSVG(SVG2JS.OFTopView), 3, this.lumCallBack,{clickx: 370, clicky: 594, clickwidth: 262, clickheight:600});
  this.lums[4] = new OLIVIO.NestedSVG(draw, SVG2JS.getPartSVG(SVG2JS.OFTopView), 4, this.lumCallBack,{clickx: 370, clicky: 594, clickwidth: 262, clickheight:600});
  this.lums[5] = new OLIVIO.NestedSVG(draw, SVG2JS.getPartSVG(SVG2JS.OFTopView), 5, this.lumCallBack,{clickx: 370, clicky: 594, clickwidth: 262, clickheight:600});
  this.lums[6] = new OLIVIO.NestedSVG(draw, SVG2JS.getPartSVG(SVG2JS.OFTopView), 6, this.lumCallBack,{clickx: 370, clicky: 594, clickwidth: 262, clickheight:600});
  this.lums[7] = new OLIVIO.NestedSVG(draw, SVG2JS.getPartSVG(SVG2JS.OFTopView), 7, this.lumCallBack,{clickx: 370, clicky: 594, clickwidth: 262, clickheight:600});


  this.advancedClick = new OLIVIO.NestedSVG(draw, null, -1, this.lumCallBack,{clickx: 370, clicky: 594+400, clickwidth: 262, clickheight:600-350});
  this.advancedClick.setText(1+"");
  this.advancedClick.setSelected(true);
  //this.advancedClick.circle.hide();
  this.advancedClick.text.fill({color: '#cccccc'});
 // var advancedGrabber = draw.circle(200).stroke({ color: '#000000', width: 2 }).fill({ color: '#000000', opacity: 1.0 });
  //advancedGrabber.move(398,840+40+215*0.5);
  //this.advancedClick.group.add(advancedGrabber);
  //advancedGrabber.back();


  this.advancedClick.group.move(250,250);
  this.advancedClick.group.hide();

  textY = textYF;

  this.floracionPoleTop = this.draw.circle(220).fill({ color: '#ffffff' }).stroke({ color: '#000000', width:4 });
  this.floracionPoleTop.move(640,640);
  this.floracionPoleTop.hide();

  this.secondClickArea = this.draw.circle(200).fill({ color: '#ff44a0', opacity: (OLIVIO.debug ? 0.1 : 0.0) });
  this.secondClickArea.move(650,650);



  if (poleClickCallBack) {
    this.poleTop.clickArea.node.style.cursor = 'pointer';
    this.poleTop.clickArea.on('click', this.poleClickCallBack);

    this.secondClickArea.node.style.cursor = 'pointer';
    this.secondClickArea.on('click', this.poleClickCallBack);
  }

  for (var i = 0; i < this.lums.length; i++) {

    this.lums[i].setText((i+1).toString());
    this.lums[i].text.fill({color:'#909090'});
    this.lums[i].textGroup.move(textX,textY);
    this.lums[i].circle.hide();
    this.lums[i].group.hide();
    this.lums[i].group.move(250,250);
    this.lums[i].source = '';
    this.lumgrp.add(this.lums[7-i].group);
  }


  this.lumVisible = function (lumIndex, value) {
    if (value) {
      this.lums[lumIndex].group.show();
    } else {
      this.lums[lumIndex].group.hide();
    }
  };

  this.rotation = function (index, rotdegree,tx,ty) {
    //console.log(index+' degrees: '+rotdegree);
    this.lums[index].rotate(rotdegree - 90, 750, 750);
    this.lums[index].rotateText(-(rotdegree - 90),tx+40,ty+40);
    if (index === OLIVIO.cmodel.singleSelectedLum && this.isSelectable === true) {
      //this.lums[index].rotateNestedLikeThis(this.advancedClick);
      this.advancedClick.setText(this.lums[index].textValue);
      this.advancedClick.textGroup.move(tx,840+215);
      this.advancedClick.rotate(rotdegree - 90, 750, 750);
      this.advancedClick.rotateText(-(rotdegree - 90),tx+40,840+40+215+5);
      this.advancedClick.nindex = index;
      this.advancedClick.group.show();
      //this.lums[index].rotateNestedLikeThis(this.advancedClick);
      //this.lums[index].rotateTextLikeThisText(this.advancedClick.textGroup);

      //this.advancedClick.group.rotate(this.lums[index].rotation, 750, 750);
    }
    //console.log(textY);

  };

  this.unBindHandlers = function () {
    if (poleClickCallBack) {
      this.poleTop.clickArea.off('click', this.poleClickCallBack);
      this.secondClickArea.off('click', this.poleClickCallBack);
    }
    for (var l = 0; l < this.lums.length; l++) {
      this.lums[l].unBindHandlers();
    }
  };



  this.updateLums = function () {
    console.log('v------ poleTop.updateLums ', (OLIVIO.cmodel.product === OLIVIO.PRODUCT_CANDELABRA) ? 'CANDELABRA ' : '', (OLIVIO.cmodel.product === OLIVIO.PRODUCT_FLORACION) ? 'FLORACION ' : '', OLIVIO.cmodel.isAdvancedMode() ? '   ADVANCED MODE!!!' :'');


    self.advancedClick.group.hide();
    if (OLIVIO.cmodel.product === OLIVIO.PRODUCT_CANDELABRA) {
      self.floracionPoleTop.hide();
      updateCandelabra();
      console.log('^------ poleTop.updateLums ended after updateCandelabra')
      return;
    } else if (OLIVIO.cmodel.product === OLIVIO.PRODUCT_FLORACION) {
      self.floracionPoleTop.show();
    } else {
      self.floracionPoleTop.hide();
    }


    if (self.arcAngle !== OLIVIO.cmodel.getTopToBottomRotation()) {
      //console.log('+------ poleTop.updateLums: self.arcAngle !== OLIVIO.cmodel.getTopToBottomRotation()');
      self.arcAngle = OLIVIO.cmodel.getTopToBottomRotation();
      self.svgCirc.clear();
      self.svgCirc.svg(getSVGArc(self.arcAngle,'#000000'));
      self.rectEnd.rotate(self.arcAngle, 750, 750);
    }



    self.clockwise = OLIVIO.cmodel.getTopToBottomRotationCW();

    var rotation = OLIVIO.cmodel.startRotation;
    rotation  += 90;
    if (rotation >= 360) {
      rotation -= 360;
    }

    updateRotationPath(rotation);

    var snapRotation = (360 - (360 / OLIVIO.cmodel.currentLumCount));
    if (OLIVIO.cmodel.getTopToBottomRotationCW() === false) {
      snapRotation = 360 - snapRotation;
    }
    snapRotation = snapRotation + rotation;
    if (snapRotation >= 360) {
      snapRotation -= 360;
    }

    var ptlrs = OLIVIO.rotatePoint(750, 1450, 750, 750, snapRotation);
    self.rectDistri.move((ptlrs.x - 20), (ptlrs.y - 20));


    var modellums = OLIVIO.cmodel.getLumieres();
    var lumNumber = 1;


    for (var l = 0; l < OLIVIO.cmodel.maxLums; l++) {
      var modellum = modellums[l];

      this.lums[l].setColor(modellum.colorFill,modellum.colorOutline,modellum.colorFillInlay,modellum.colorFillSelected,modellum.colorOutlineSelected,modellum.colorFillInlaySelected);
      if (modellum.lumVisible === true) {
        this.lums[l].setText((lumNumber).toString());
        lumNumber++;
      }

      var source = SVG2JS.OFTopView;
      //this.lums[l].textGroup.rotate(0,textX+40,textY+40);
      textY = textYF;

      if (OLIVIO.cmodel.product === OLIVIO.PRODUCT_SISTEMA) {
        if (modellum.lumType === OLIVIO.LUM_GRANDE) {
          if (modellum.bracketType === OLIVIO.BRACKET_SISTEMA1) {
            source = SVG2JS.OSGS1Top;
            textY = textYS1G;
          } else if (modellum.bracketType === OLIVIO.BRACKET_SISTEMA2) {
            source = SVG2JS.OSGS2Top;
            textY = textYS2G;
          } else if (modellum.bracketType === OLIVIO.BRACKET_SISTEMA3) {
            source = SVG2JS.OSGS3Top;
            textY = textYS3G;
          }
        } else if (modellum.lumType === OLIVIO.LUM_MEDIO) {
          if (modellum.bracketType === OLIVIO.BRACKET_SISTEMA1) {
            source = SVG2JS.OSMS1Top;
            textY = textYS1M;
          } else if (modellum.bracketType === OLIVIO.BRACKET_SISTEMA2) {
            source = SVG2JS.OSMS2Top;
            textY = textYS2M;
          } else if (modellum.bracketType === OLIVIO.BRACKET_SISTEMA3) {
            source = SVG2JS.OSMS3Top;
            textY = textYS3M;
          }
        } else {
          // must be piccolo --- piccolo is now supported and it's always mounted to OLIVIO.BRACKET_SISTEMA3
          source = SVG2JS.OSPS3Top;
          textY = textYS3P;
        }

      }

      var sourceCode = OLIVIO.cmodel.product + modellum.bracketType + modellum.lumType;

      console.log('+------ poleTop.updateLums '+i+':', this.lums[l].source !== sourceCode ? 'new sourceCode, ' : 'same sourceCode, ', modellum.lumVisible ? 'visible, ' : 'hidden, ', this.lums[l].selected ? 'selected' : 'unselected');

      if (this.lums[l].source !== sourceCode) {
        this.lums[l].textGroup.move(textX,textY);
        self.lums[l].updateSVGraw(SVG2JS.getPartSVG(source));
        this.lums[l].source = sourceCode;
        this.lums[l].repaint();
      }
      self.rotation(l, modellum.lumRotationCombined,textX,textY);
      self.lumVisible(l, modellum.lumVisible);


      this.lums[l].setSelected(
        (OLIVIO.cmodel.firstAndLastLumSelected && (l===0 || l===7)) ||
        (!OLIVIO.cmodel.firstAndLastLumSelected && l === OLIVIO.cmodel.singleSelectedLum)
      );

      var cursorStyleFromRotation = "";
      if (modellum.lumRotationCombined >= 22.5 && modellum.lumRotationCombined <= 67.5) {
        cursorStyleFromRotation = 'nesw-resize';
      } else if (modellum.lumRotationCombined >= 67.5 && modellum.lumRotationCombined <= 112.5) {
        cursorStyleFromRotation = 'ew-resize';
      } else if (modellum.lumRotationCombined >= 112.5 && modellum.lumRotationCombined <= 157.5) {
        cursorStyleFromRotation = 'nwse-resize';
      } else if (modellum.lumRotationCombined >= 157.5 && modellum.lumRotationCombined <= 202.5) {
        cursorStyleFromRotation = 'ns-resize';
      } else if (modellum.lumRotationCombined >= 202.5 && modellum.lumRotationCombined <= 247.5) {
        cursorStyleFromRotation = 'nesw-resize';
      } else if (modellum.lumRotationCombined >= 247.5 && modellum.lumRotationCombined <= 292.5) {
        cursorStyleFromRotation = 'ew-resize';
      } else if (modellum.lumRotationCombined >= 292.5 && modellum.lumRotationCombined <= 337.5) {
        cursorStyleFromRotation = 'nwse-resize';
      } else {
        cursorStyleFromRotation = 'ns-resize';
      }
      this.lums[l].setCursorStyle(!this.mastSelected && (OLIVIO.cmodel.isAdvancedMode() || this.lums[l].selected) ? cursorStyleFromRotation : 'default');

    }



    this.poleTop.setCursorStyle(OLIVIO.cmodel.isAdvancedMode() ? 'default' : 'pointer');

    console.log('^------ poleTop.updateLums ');
  };


  var updateCandelabra = function () {
    console.log('updateCandelabra ', OLIVIO.cmodel.lumType, OLIVIO.cmodel.currentLumCount, OLIVIO.cmodel.currentLumCount === parseInt(OLIVIO.cmodel.currentLumCount));
    self.poleTop.group.move(250, 250);
    self.poleTop.clickArea.scale(0.01,0.01);

    self.rotationPathGroup.hide();

    if (OLIVIO.cmodel.lumType === OLIVIO.LUM_GRANDE) {
      if (OLIVIO.cmodel.currentLumCount === 1) {
        self.poleTop.updateSVGraw(SVG2JS.getPartSVG(SVG2JS.OCG1Top));
      } else if (OLIVIO.cmodel.currentLumCount === 2) {
        if (OLIVIO.cmodel.getTopToBottomRotation() === 120) {
          self.poleTop.updateSVGraw(SVG2JS.getPartSVG(SVG2JS.OCG2Top120));
        } else {
          self.poleTop.updateSVGraw(SVG2JS.getPartSVG(SVG2JS.OCG2Top180));
        }
      } else {
        self.poleTop.updateSVGraw(SVG2JS.getPartSVG(SVG2JS.OCG3Top));
      }
    } else {
      if (OLIVIO.cmodel.currentLumCount === 1) {
        self.poleTop.updateSVGraw(SVG2JS.getPartSVG(SVG2JS.OCM1Top));
      } else if (OLIVIO.cmodel.currentLumCount === 2) {
        if (OLIVIO.cmodel.getTopToBottomRotation() === 120) {
          self.poleTop.updateSVGraw(SVG2JS.getPartSVG(SVG2JS.OCM2Top120));
        } else {
          self.poleTop.updateSVGraw(SVG2JS.getPartSVG(SVG2JS.OCM2Top180));
        }
      } else {
        self.poleTop.updateSVGraw(SVG2JS.getPartSVG(SVG2JS.OCM3Top));
      }
    }
    self.repaintPole();
  };

  var updateRotationPath = function (rotation) {
    //console.log('lib_poletop:: updateRotationPath '+(OLIVIO.cmodel.firstAndLastLumSelected && !this.mastSelected && !OLIVIO.cmodel.isAdvancedMode()), self.clockwise ? 'clockwise' : 'counter clockwise');
    if (OLIVIO.cmodel.firstAndLastLumSelected && !this.mastSelected && !OLIVIO.cmodel.isAdvancedMode()) {
      if (self.clockwise) {
        self.rotationPathGroup.rotate(rotation, 750, 750);
        self.rectStart.move(750-20,150-20);
        self.rectStart.size(40,40);
        self.rectEnd.move(750-3,150-20);
        self.rectEnd.size(6,40);
      } else {
        self.rotationPathGroup.rotate(rotation+(360-self.arcAngle), 750, 750);
        self.rectEnd.move(750-20,150-20);
        self.rectEnd.size(40,40);
        self.rectStart.move(750-3,150-20);
        self.rectStart.size(6,40);
      }
      self.rotationPathGroup.show();
      //self.lums[0].text.fill({color: '#cccccc'});
      //self.lums[7].text.fill({color: '#cccccc'});
    } else {
      self.rotationPathGroup.hide();
      //self.lums[0].text.fill({color: '#000000'});
      //self.lums[7].text.fill({color: '#000000'});
    }
  };

  this.repaintPole = function() {
    this.poleTop.setColor(OLIVIO.cmodel.colorMastFill,OLIVIO.cmodel.colorMastOutline,'#ffffff',OLIVIO.cmodel.colorMastFillSelected,OLIVIO.cmodel.colorMastOutlineSelected,'#000000');

    var value = OLIVIO.cmodel.mastSelected && !(OLIVIO.cmodel.product === OLIVIO.PRODUCT_CANDELABRA); // FIXME müsste Mast bei Candelabra nicht immer ausgewählt sein?

    this.poleTop.setSelected(value);
    if (value === true) {
      self.floracionPoleTop.fill({ color: OLIVIO.cmodel.colorMastFillSelected }).stroke({ color: OLIVIO.cmodel.colorMastOutlineSelected });
    } else {
      self.floracionPoleTop.fill({ color: OLIVIO.cmodel.colorMastFill  }).stroke({ color: OLIVIO.cmodel.colorMastOutline });
    }
  }
  this.repaint = function() {
    this.repaintPole();
    this.updateLums();
  };

  this.setWhite = function () {
    self.poleTop.setWhiteStrokes();
    this.floracionPoleTop.fill({ color: '#ff44a0', opacity: 0.0 }).stroke({ color: '#ffffff' });
    self.circBG.stroke({ color: '#ffffff', width: 6, opacity: 0.1 });
    self.svgCirc.svg(getSVGArc(self.arcAngle,'#ffffff'));
    self.rectEnd.fill({ color: '#ffffff', opacity: 1.0 });
    self.rectStart.fill({ color: '#ffffff', opacity: 1.0 });
    for (var i = 0; i < this.lums.length; i++) {
      this.lums[i].setWhiteStrokes();
    }
  };

};

